import { styled } from "@mui/system";
import { Button, Step, Stepper, TextField } from "@mui/material";
import COLORS from "./Colors";
import FONTS_FAMILY from "./FontsFamily";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DeleteIcon from "@mui/icons-material/Delete";
import { MUIStyledCommonProps } from "@mui/system";

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const Row = styled("div")({
  display: "flex",
  flexDirection: "row",
});

export const Column = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export const BodyCard = styled("div")({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  backgroundColor: COLORS.white,
  width: "90%",
  marginTop: "20px",
  minHeight: "10vh",
  borderRadius: "8px",
  alignSelf: "center",
  boxShadow:
    "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
  padding: "10px",
  "@media (min-width:320px)": {
    marginLeft: 0,
  },
  "@media (min-width:768px)": {
    marginLeft: "65px",
  },
  "@media (min-width:1200px)": {
    marginLeft: "65px",
  },
});

export const StyledButton = styled(Button)({
  minHeight: "52px",
  padding: "16px",
  width: "100%",
  borderRadius: 5,
  color: COLORS.white,
  backgroundColor: COLORS.primary,
  "@media (min-width:320px)": {
    fontSize: "12px",
  },
  "@media (min-width:768px)": {
    fontSize: "15px",
  },
  "@media (min-width:1200px)": {
    fontSize: "16px",
  },
  fontFamily: FONTS_FAMILY.body,
  fontWeight: 500,
  textTransform: "none",
  "&:hover,&:focus,&:active": {
    color: COLORS.white,
    backgroundColor: COLORS.primary,
  },
  "&:disabled": {
    color: COLORS.gray,
    backgroundColor: "#EEEEEE",
  },
});

export const StyledButtonOutlined = styled(Button)({
  minHeight: "52px",
  padding: "16px",
  width: "100%",
  borderColor: COLORS.primary,
  borderRadius: 5,
  color: COLORS.primary,
  backgroundColor: COLORS.white,
  "@media (min-width:320px)": {
    fontSize: "12px",
  },
  "@media (min-width:768px)": {
    fontSize: "15px",
  },
  "@media (min-width:1200px)": {
    fontSize: "16px",
  },
  fontFamily: FONTS_FAMILY.body,
  fontWeight: 500,
  textTransform: "none",
  "&:hover,&:focus,&:active": {
    color: COLORS.white,
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
  },
});

export const StyledTextInput = styled(TextField)({
  width: "100%",
  alignSelf: "center",
  borderWidth: "5px",
  "& .MuiInputBase-input ": {
    width: "100%",
    fontSize: "18px",
    backgroundColor: COLORS.white,
    padding: 10,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: COLORS.fieldGrayInput,
      borderRadius: "8px",
      minHeight: "45px",
      borderWidth: "1.8px",
    },

    "&:hover fieldset": {
      //    borderColor: COLORS.secondary,
    },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.primary,
      borderWidth: "1px",
    },
  },
});

export const LanguageContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignSelf: "center",
  marginTop: "60px",
  justifyContent: "space-evenly",
  width: "150px",
});

export const SmallCircleImageButton = styled("img")({
  borderRadius: "100%",
  height: "50px",
  width: "50px",
  cursor: "pointer",
});

export const StyledLink = styled(Link)({
  margin: 0,
  fontFamily: FONTS_FAMILY.body,
  fontWeight: 500,
  fontSize: "15px",
});

export const BodyText = styled("p")({
  margin: 0,
  textAlign: "left",
  fontSize: "15px",
  color: COLORS.black,
  fontFamily: FONTS_FAMILY.body,
  fontWeight: 500,
});

export const BodyTextBold = styled("p")({
  margin: 0,
  textAlign: "left",
  fontSize: "15px",
  color: "#000000",
  fontFamily: FONTS_FAMILY.title,
  fontWeight: 900,
});

export const Title = styled("h1")({
  margin: 0,
  fontFamily: FONTS_FAMILY.title,
  fontWeight: 900,
  fontSize: "35px",
  "@media(max-width:768px)": {
    fontSize: "30px",
  },
  color: COLORS.primary,
});

export const SubTitle = styled("h4")({
  margin: 0,
  fontFamily: FONTS_FAMILY.title,
  fontWeight: 900,
  fontSize: "30px",
  "@media(max-width:768px)": {
    fontSize: "20px",
  },
  color: COLORS.primary,
});

export const SmallHeightDivider = styled("div")({
  height: "15px",
});

export const MediumHeightDivider = styled("div")({
  height: "60px",
});

export const ButtonsMenuContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  "@media (min-width:320px)": {
    width: "90%",
  },
  "@media (min-width:768px)": {
    width: "80%",
  },
  "@media (min-width:1200px)": {
    width: "70%",
  },
});

export const FieldTitle = styled("p")({
  marginTop: "3px",
  color: COLORS.black,
  fontFamily: FONTS_FAMILY.body,
  fontWeight: 500,
  "@media (min-width:320px)": {
    fontSize: "11px",
  },
  "@media (min-width:768px)": {
    fontSize: "15px",
  },
  "@media (min-width:1200px)": {
    fontSize: "17px",
  },
});

export const StyledPagination = styled(Pagination)({
  "& .MuiPaginationItem-rounded": {
    "&:hover,&:focus": {
      backgroundColor: COLORS.primary,
      color: COLORS.white,
    },
  },
  "& .Mui-selected": {
    backgroundColor: `${COLORS.tertiary} !important`,
    color: COLORS.white,
  },
  "& .MuiPaginationItem-root": {
    "&:hover,&:focus": {
      backgroundColor: COLORS.tertiary,
      color: COLORS.white,
    },
  },
});

export const StyledCancelIcon = styled("div")({
  color: COLORS.error,
  "@media (min-width:320px)": {
    fontSize: "150px",
  },
  "@media (min-width:768px)": {
    fontSize: "200px",
  },
  "@media (min-width:1200px)": {
    fontSize: "250px",
  },
});

interface TableDivProps {
  disableMinHeight?: boolean;
}

export const TableDiv = styled("div")<TableDivProps>((props) => ({
  minHeight: props?.disableMinHeight ? "10px" : "61vh",
  maxHeight: "430px",
  width: "100%",
  position: "relative",
  display: "flex",
  overflow: "auto",
  flexDirection: "column",
  alignSelf: "center",
}));

export const PaginationContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  alignItems: "center",
  width: "100%",
});

export const HeaderContainer = styled("div")({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
  "@media (min-width:320px)": {
    alignSelf: "flex-start",
    flexDirection: "column",
  },
  "@media (min-width:768px)": {
    alignSelf: "center",
    flexDirection: "column",
  },
  "@media (min-width:1200px)": {
    alignSelf: "flex-end",
    flexDirection: "row",
  },
});

export const FilterContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignSelf: "flex-end",
  "@media (min-width:320px)": {
    width: "100%",
  },
  "@media (min-width:768px)": {
    width: "100%",
  },
  "@media (min-width:1200px)": {
    width: "70%",
  },
});

export const SearcherContainer = styled("div")({
  width: "85%",
});

export const ButtonHeaderContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "10px",
  "@media (min-width:320px)": {
    width: "100%",
  },
  "@media (min-width:768px)": {
    width: "50%",
  },
});

export const StyledCheckCircleIcon = styled(CheckCircleIcon)({
  color: COLORS.primary,
  fontSize: "30px",
  cursor: "pointer",
});

interface unclickeableProps extends MUIStyledCommonProps {
  unclickeable?: boolean;
}

export const StyledCheckBoxOutlineBlankIcon = styled(
  CheckBoxOutlineBlankIcon
)<unclickeableProps>((props) => ({
  color: COLORS.primary,
  cursor: props?.unclickeable ? "auto" : "pointer",
}));

export const StyledCheckBoxIcon = styled(CheckBoxIcon)<unclickeableProps>(
  (props) => ({
    color: COLORS.primary,
    cursor: props.unclickeable ? "auto" : "pointer",
  })
);

export const StyledDeleteIcon = styled(DeleteIcon)({
  color: COLORS.primary,
  fontSize: "30px",
  cursor: "pointer",
});

export const StyledTableImage = styled("img")({
  objectFit: "cover",
  cursor: "pointer",
  width: "75px",
  height: "75px",
});

export const StyledTableMiniImage = styled("img")({
  objectFit: "cover",
  cursor: "pointer",
  width: "30px",
  height: "30px",
});

export const StyledStep = styled(Step)({
  "& .MuiStepLabel-iconContainer .Mui-active": {
    color: COLORS.primary,
  },
  "& .MuiStepLabel-iconContainer .Mui-completed": {
    color: COLORS.primary,
  },
});
